import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { BailModel } from './bail.model';
import { environment } from '../../../../environments/environment';
import { ResultModel } from '../../../shared/result.model';
import { ResultTotalModel } from '../../../shared/total.model';
import { ApiResponse } from '../../../models/base';

const LIST_ENDPOINT = '/bails';

interface ApiMessageResponse {
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class BailService {
  bailList: BailModel[] = [];

  constructor(private http: HttpClient) {}

  addData(bail: BailModel): Promise<BailModel> {
    return firstValueFrom(
      this.http.post<ApiResponse<BailModel>>(environment.apiUrl + LIST_ENDPOINT, bail)
    ).then((response) => response.data);
  }

  deleteData(uid: string): Promise<string> {
    return firstValueFrom(
      this.http.delete<ApiMessageResponse>(environment.apiUrl + LIST_ENDPOINT + `/${uid}`)
    ).then((response) => response.message);
  }

  editData(uid: string, bail: BailModel): Promise<BailModel> {
    return firstValueFrom(
      this.http.put<ApiResponse<BailModel>>(environment.apiUrl + LIST_ENDPOINT + `/${uid}`, bail)
    ).then((response) => response.data);
  }

  loadData(uid: string): Promise<BailModel> {
    return firstValueFrom(
      this.http.get<ApiResponse<BailModel>>(environment.apiUrl + LIST_ENDPOINT + `/${uid}`)
    ).then((response) => response.data);
  }

  getList(offset?: number, limit?: number): Promise<ResultModel<BailModel>> {
    const params = new HttpParams();

    if (offset !== undefined) {
      // params = params.set('offset', offset.toString());
    }

    if (limit !== undefined) {
      // params = params.set('limit', limit.toString());
    }

    return firstValueFrom(
      this.http.get<ApiResponse<ResultModel<BailModel>>>(environment.apiUrl + LIST_ENDPOINT, { params })
    ).then((response) => response.data);
  }

  getTotal(): Promise<ResultTotalModel[]> {
    return firstValueFrom(
      this.http.get<ApiResponse<ResultTotalModel[]>>(environment.apiUrl + LIST_ENDPOINT + '/total')
    ).then((response) => response.data);
  }

  getInvoiceTotal(): Promise<ResultTotalModel[]> {
    return firstValueFrom(
      this.http.get<ApiResponse<ResultTotalModel[]>>(environment.apiUrl + LIST_ENDPOINT + '/invoice/total')
    ).then((response) => response.data);
  }

  getInvoiceList(offset?: number, limit?: number): Promise<ResultModel<BailModel>> {
    const params = new HttpParams();

    if (offset !== undefined) {
      // params = params.set('offset', offset.toString());
    }

    if (limit !== undefined) {
      // params = params.set('limit', limit.toString());
    }

    return firstValueFrom(
      this.http.get<ApiResponse<ResultModel<BailModel>>>(
        environment.apiUrl + LIST_ENDPOINT + '/invoice',
        { params }
      )
    ).then((response) => response.data);
  }
}